import SiteLayout from '@/components/feature/SiteLayout';
import { dramas } from '@/mocks/dramas';
import HeroSlider from '@/pages/home/components/HeroSlider';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import HomeSections from '@/pages/home/components/HomeSections';
import HomeIntro from '@/pages/home/components/HomeIntro';
import HomeCta from '@/pages/home/components/HomeCta';

const featured = [...dramas].sort((a, b) => b.popularity - a.popularity).slice(0, 5);

export default function Home() {
  return (
    <SiteLayout>
      <h1 className="sr-only">伦理片在线观看 - 最新伦理剧集在线观看平台</h1>
      <HeroSlider items={featured} />
      <CategoryShortcuts />
      <HomeSections />
      <HomeIntro />
      <HomeCta />
    </SiteLayout>
  );
}